import { PRIVATE_PAGE_ROUTES } from '@/enums';

export const OFFLINE_ALLOWED_ROUTES = [PRIVATE_PAGE_ROUTES.PLAYLISTS, PRIVATE_PAGE_ROUTES.EVENTS];

export const isRouteOfflineAllowed = (path?: string): boolean => {
  if (!path) {
    return false;
  }

  return OFFLINE_ALLOWED_ROUTES.some(
    (allowed) => path === allowed || path.startsWith(allowed + '/')
  );
};
